import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import styles from './Composer.module.css'

export function CommandSuggestions({ text, onChoose }: { text: string; onChoose: (text: string) => void }) {
  const { data } = useQuery({ queryKey: ['commands'], queryFn: ({ signal }) => api.get<{ commands: { name: string; description: string; arguments: string }[] }>('/commands', undefined, signal), staleTime: Infinity })
  if (!/^\/[a-z]*$/.test(text)) return null
  return <div aria-label="Commands" className={styles.commandList}>
    {data?.commands.filter(command => command.name.startsWith(text.slice(1))).map(command => <button type="button" key={command.name} onClick={() => onChoose(`/${command.name} `)}>
      <strong>/{command.name} {command.arguments}</strong><span>{command.description}</span>
    </button>)}
  </div>
}
